import { render } from "./blooDhound.vue?vue&type=template&id=790f8e22"
import script from "./blooDhound.vue?vue&type=script&lang=js"
export * from "./blooDhound.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__